import { render, staticRenderFns } from "./DzListGroupItemNoauth.vue?vue&type=template&id=a8fb2ba8&scoped=true"
import script from "./DzListGroupItemNoauth.vue?vue&type=script&lang=js"
export * from "./DzListGroupItemNoauth.vue?vue&type=script&lang=js"
import style0 from "./DzListGroupItemNoauth.vue?vue&type=style&index=0&id=a8fb2ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fb2ba8",
  null
  
)

export default component.exports